module.exports = __webpack_public_path__ + "img/src/modules/web-agent/assets/img/maven-close.png?bad25789cf2706313a8c1de5c9fd5ae4";